var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2h8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1M0 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm4.748.566A.5.5 0 0 0 4 4v4a.5.5 0 0 0 .748.434l3.5-2a.5.5 0 0 0 0-.868zM6.992 6 5 7.138V4.862z",
    clipRule: "evenodd"
  })));
});
const SvgVideosmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideosmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDJIMTBDMTAuNTUyMyAyIDExIDIuNDQ3NzIgMTEgM1Y5QzExIDkuNTUyMjkgMTAuNTUyMyAxMCAxMCAxMEgyQzEuNDQ3NzIgMTAgMSA5LjU1MjI4IDEgOVYzQzEgMi40NDc3MiAxLjQ0NzcyIDIgMiAyWk0wIDNDMCAxLjg5NTQzIDAuODk1NDMxIDEgMiAxSDEwQzExLjEwNDYgMSAxMiAxLjg5NTQzIDEyIDNWOUMxMiAxMC4xMDQ2IDExLjEwNDYgMTEgMTAgMTFIMkMwLjg5NTQzMSAxMSAwIDEwLjEwNDYgMCA5VjNaTTQuNzQ4MDcgMy41NjU4OEM0LjU5MzMyIDMuNDc3NDUgNC40MDMxOSAzLjQ3ODA4IDQuMjQ5MDQgMy41Njc1NEM0LjA5NDg4IDMuNjU3MDEgNCAzLjgyMTc2IDQgNFY4QzQgOC4xNzgyNCA0LjA5NDg4IDguMzQyOTkgNC4yNDkwNCA4LjQzMjQ2QzQuNDAzMTkgOC41MjE5MiA0LjU5MzMyIDguNTIyNTUgNC43NDgwNyA4LjQzNDEyTDguMjQ4MDcgNi40MzQxMkM4LjQwMzg2IDYuMzQ1MSA4LjUgNi4xNzk0MyA4LjUgNkM4LjUgNS44MjA1NyA4LjQwMzg2IDUuNjU0OSA4LjI0ODA3IDUuNTY1ODhMNC43NDgwNyAzLjU2NTg4Wk02Ljk5MjIyIDZMNSA3LjEzODQxVjQuODYxNTlMNi45OTIyMiA2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";